import React from 'react';
import { motion } from 'framer-motion';
import { talentExample, talentFeatures } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';
export function TalentDetails() {
  return <div className="space-y-16" data-id="element-849" data-mp="kmigom5hvs9z">
      <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-850" data-mp="klfp0c0cllt0">
        <h3 className="lg:col-span-5 font-heading font-bold text-lg text-ink-dark" data-id="element-851" data-mp="pjqxojewpq9n">Employers could:</h3>
        <dl className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 border-t border-line" data-id="element-852" data-mp="bjpngdcr56hi">
          {talentFeatures.map(feature => <div key={feature.title} className="border-b border-line py-5" data-id="element-853" data-mp="1nctrfh7ismr">
              <dt className="font-heading font-semibold text-ink-dark mb-1" data-id="element-854" data-mp="1ph8ksgn9c1t">{feature.title}</dt>
              <dd className="text-ink-muted leading-relaxed" data-id="element-855" data-mp="6oad3vdydspu">{feature.text}</dd>
            </div>)}
        </dl>
      </motion.div>

      <motion.figure {...fadeUp} data-id="element-856" data-mp="210qn979vdqzz">
        <figcaption className="font-heading font-bold text-lg text-ink-dark mb-4" data-id="element-857" data-mp="20zp3meesfw6n">
          For a project manager role, the review might show:
        </figcaption>
        <div className="overflow-x-auto border border-line rounded-lg bg-white" data-id="element-858" data-mp="3uf63eh4a1qiv">
          <table className="w-full min-w-[640px] text-left" data-id="element-859" data-mp="cxmx10vppo65">
            <thead className="bg-surface-muted" data-id="element-860" data-mp="cx3af6v4abls">
              <tr data-id="element-861" data-mp="7ya0fof1h2qd">
                <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark w-1/5" data-id="element-862" data-mp="7zuvrg96gppa">Requirement</th>
                <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-863" data-mp="3gf52j1o0ij3e">What the candidate demonstrated</th>
                <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-864" data-mp="3bhmo4vr87bo0">What remains unclear</th>
              </tr>
            </thead>
            <tbody data-id="element-865" data-mp="3lcn2i2k1xnz9">
              {talentExample.map(row => <tr key={row.requirement} className="border-t border-line align-top" data-id="element-866" data-mp="14p2igrlj94us">
                  <th scope="row" className="px-6 py-5 font-heading font-semibold text-ink-dark" data-id="element-867" data-mp="14qx3e5wt0wyv">
                    {row.requirement}
                  </th>
                  <td className="px-6 py-5 text-ink-dark leading-relaxed" data-id="element-868" data-mp="3th5zqyfq17r0">{row.demonstrated}</td>
                  <td className="px-6 py-5 text-ink-muted leading-relaxed" data-id="element-869" data-mp="2acyjukxh8mh">{row.unclear}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.figure>
    </div>;
}